import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useFetch from "../Hooks/useFetch";
import { organizationsURL } from "../Hooks/URL";
import { userContext } from "../Contexts/userContext";
import Organizations from "../Templates/Home/Organizations/Organizations";

function OrganizationsPage() {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchData, setSearchData] = useState("");
  const [search, setSearch] = useState("");
  const [Open, setOpen] = useState(false);

  const [organizations, setOrganizations] = useState([]);
  const [organizationsNumber, setOrganizationsNumber] = useState(0);
  const { data, loading, error } = useFetch(
    organizationsURL,
    page,
    rowsPerPage,
    search,
    null,
    false
  );

  useEffect(() => {
    if (!loading && !error && data) {
      setOrganizations(data.data.data.rows);
      setOrganizationsNumber(data.data.data.totalCount);
      setPageCount(data.data.data.numberOfPages);
    }
  }, [data, loading, error]);

  useEffect(() => {
    setContextData({ ...contextData, page: "organizations", data: "" });
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Organizations
      page={page}
      rowsPerPage={rowsPerPage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      searchData={searchData}
      search={search}
      setSearchData={setSearchData}
      setSearch={setSearch}
      organizations={organizations}
      navigate={navigate}
      handleChangePage={handleChangePage}
      Open={Open}
      setOpen={setOpen}
      loading={loading}
      data={data}
      error={error}
      pageCount={pageCount}
      setOrganizations={setOrganizations}
      organizationsNumber={organizationsNumber}
    />
  );
}

export default OrganizationsPage;
